import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from './Header';
import Footer from '../../components/Footer/Footer';
import Join from '../../components/JoinModal/JoinModal';
import Modal from '../../components/Modal/Modal';

class Education extends Component {
  state = {
    modal: false
  }
  render() {
    const styles = require('./Education.less');

    return [
      <Helmet
        key="0"
        htmlAttributes={{ lang: 'ru-RU' }}
        title="Обучение и внедрение онлайн сервиса для создания опросов и сбора отзывов (обратной связи) / оценок и аналитики от Клиентов (ЦА) – Mvoter.com"
        meta={[{ name: 'description', content: 'Обучение и внедрение MVoter – Онлайн платформа для создания моментальной обратной связи с Клиентами! Онлайн сервис по сбору отзывов ✓ Анализ обратной связи от ЦА и потребителей ✓ Управление удовлетворенностью клиентов ✓ Отрасли использования опросника: Рестораны, Банки, Здравоохранение, Торговля, Общественный транспорт ☎ +7 (747) 359-5959' }]}
      />,
      <Header key="1" />,
      <div key="2" className={ styles.content }>
        <div className={ styles.inner }>
          <div className={ styles.wrap }>
            <h1>Обучение и внедрение MVoter</h1>
            <p>Прежде всего обращаем ваше внимание на то что IT платформа Mvoter проста, понятна и удобна!</p>
            <p>Для того чтобы понять и внедрить её не нужно быть IT специалистом. Тем не менее, для удобства наших клиентов консультанты компании Mvoter помогут вам внедрить систему обратной связи с вашей целевой аудиторией. За каждым нашим клиентом мы закрепляем персонального менеджера консультанта. Вы можете обращаться к нему через email и иные средства связи. Наши консультанты помогут вам выбрать оптимальные параметры настройки системы. В случае если потребуется интегрировать Mvoter с действующими в вашей компании CRM и иными системами, наши технические специалисты помогут решить данную задачу.</p>
            <p>Если ваша компания подписана на тариф “Премиум” мы проведем для ваших сотрудников 1 часовое обучение по работе с системой Mvoter. Если вы владелец тарифа “Энтерпрайз” то мы проведем для ваших сотрудников 3-х часовое обучение.</p>
            <p>Вне зависимости от вашего тарифа мы оказываем консультацию и поддержку в режиме 24/7 для всех наших клиентов!</p>
            <div className={ styles.imgWrap }>
              <img src="./images/education.svg" width="690" height="370" alt="education" />
            </div>
            <h3>Создайте систему обратной связи сейчас. Это просто.</h3>
            <ul className={ styles.buttons }>
              <li><span onClick={ () => this.setState({ modal: true }) }>Регистрация</span></li>
              <li><span onClick={ () => this.setState({ modal: true }) }>Запросить демонстрацию</span></li>
            </ul>
          </div>
        </div>
        { this.state.modal
          && (
            <Modal
              title="Запросить демонстрацию"
              content={ <Join onCloseClick={ () => this.setState({ modal: false }) } /> }
              onCloseClick={ () => this.setState({ modal: false }) }
            />
          )}
      </div>,
      <Footer key="3" subId="page" />
    ];
  }
}

export default Education;
